import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const ModalBackdrop = ({ children, onClose, mobileBottomSheet = false, maxWidthClass = 'max-w-lg' }) => {
    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        
        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, []);

    return ReactDOM.createPortal(
        <div 
            className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity"
            onClick={(e) => e.target === e.currentTarget && onClose()}
        >
            <div className={`w-full ${maxWidthClass} max-h-full transition-transform duration-300 ease-out ${mobileBottomSheet ? 'translate-y-0' : ''}`}>
                {children}
            </div>
        </div>,
        document.body
    );
};

export default ModalBackdrop;
